// Helferklasse für API-Zugriffe

import { defaults, get, post, delete as del } from 'axios'
import { setCookie } from '../tools'
export { handleHttpErr, login, register, loescheUser, sendeNachricht, updateNachrichten, updateOrte, updateAngebote }

function handleHttpErr(err)
{
    if (err.response) {
        if (err.response.status == 401) {
            defaults.headers.common['Authorization'] = undefined
            setCookie({ name: 'bszwmloginToken', value: "", exdays: -5 })
        }
        if (err.response.data.title)
        err.response.data = err.response.data.title
        return err
    }
    else {
        err.response = { status: 0, data: "Service ist nicht verfügbar." }
        return err
    }
}

async function updateOrte(plz){
    try {
        var res = await get('main/ort', { params: { plz: plz, max: 10 } })
        return res.data
    }
    catch (err) {
        throw handleHttpErr(err)
    }
}

async function updateAngebote(art) {
    try {
        var res = await get("users/angebote", { params: { art: art } })
        return res.data
    }
    catch (err) {
        throw handleHttpErr(err)
    }
}

async function login(userLogin) {
    try {
        var res = await post("main/login", { username: userLogin.username, password: userLogin.password })
        defaults.headers.common['Authorization'] = "bearer " + res.data
        return res.data
    }
    catch (err) {
        throw handleHttpErr(err)
    }
}

async function register(userRegister) {
    try {
        var res = await post("main/register", userRegister)
        defaults.headers.common['Authorization'] = "bearer " + res.data
        return res.data
    }
    catch (err) {
        throw handleHttpErr(err)
    }
}

async function loescheUser(userLogin) {
    try {
        await del("main/loeschen", { params: userLogin })
        defaults.headers.common['Authorization'] = undefined
    }
    catch (err) {
        throw handleHttpErr(err)
    }
}

async function sendeNachricht(nachricht) {
    try {
        var res = await post("nachrichten/" + nachricht.aid, { nachricht: nachricht.inhalt })
        return res.data
    }
    catch (err) {
        throw handleHttpErr(err)
    }
}

async function updateNachrichten(anfrage) {
    try {
        var res = await get("nachrichten/" + anfrage.id)
        return res.data
    }
    catch (err) {
        throw handleHttpErr(err)
    }
}